import React from 'react';
import PropTypes from 'prop-types';
import i18next from './locales/i18next';
import {I18nextProvider} from 'react-i18next';

import { MaterialCard } from '@learningblocks/storybook-components/lib/GelComponents/MaterialCard';
import {getImageData} from './component_data'

import style from './style.module.scss';


/**
 *  i18n Configs
 */
const i18n = i18next;

const changeLang = (lang) => {
     i18n.changeLanguage(lang);
};


export class MaterialSection extends React.Component {
     constructor(props) {
          super(props);
          this.state = {
               materials: [],
               dir: 'ltr'
          }
     }

     buildComponent = (data, index) => {
          let carddata = {
               key: index + '_' + data.props.type + '_' + data.component,
               id: data.props.id,
               fullName: i18n.t((data.props.hasOwnProperty('fullName')) ? data.props.fullName : data.props.type),
               description: i18n.t(data.props.description),
               ariaLabel: (data.props.hasOwnProperty('ariaLabel')) ? data.props.ariaLabel : '',
               isSolutionTube: (data.props.hasOwnProperty('solutionTube')) ? true : false,
               solutionTube: (data.props.hasOwnProperty('solutionTube')) ? data.props.solutionTube : {},
               contentID: '',
               image: (data.props.hasOwnProperty('solutionTube')) ? null : getImageData(data.component, data.props),
          };
          return <MaterialCard {...carddata}/>
     }

     componentDidMount(){
          changeLang(this.props.lang);
          this.setState({ 'dir': i18n.RTL_LANGs.includes(this.props.lang) ? 'rtl' : 'ltr'})
          this.doCompPart(
               this.props.materials,
               this.props.grouping
          );
     }

     doCompPart = (data, grouping) => {
          let groupArr = []

          Object.keys(grouping).forEach((key, index) => {
               let compArr = []
               grouping[key].components.forEach((component) => {
               if(data.hasOwnProperty(component)){
                    if (component == "CellSpreader") {
                         compArr.push(this.buildComponent(data[component].components[0], 0));
                    }
                    else {
                         data[component].components.forEach((comp, index) => {
                              if (comp["component"] == "Solution") {
                                   if (!grouping[key].hasOwnProperty("type")) {
                                        compArr.push(this.buildComponent(comp, index));
                                   }
                                   else if (grouping[key]["type"] == 'Filled' && comp["props"]["volume"] > 0) {
                                        compArr.push(this.buildComponent(comp, index));
                                   }
                                   else if (grouping[key]["type"] == 'Empty' && comp["props"]["volume"] == 0) {
                                        compArr.push(this.buildComponent(comp, index));
                                   }
                              }
                              else if (comp["component"] == "CellSpreader") {
                                   
                              }
                              else {
                                   compArr.push(this.buildComponent(comp, index));
                              }
                         })
                    }
               }
               });

               if(typeof compArr[0] != 'undefined'){
                    groupArr.push(
                         <div aria-label={key} key={index} className={style.Category}>
                         <h3 tabIndex={0} aria-label={key} className={style.CategoryHeading}>{key}</h3>
                         <h6 className={style.CategoryDescription} tabIndex={0}>{grouping[key].description}</h6>
                         <div aria-label={key} className={style.Group}>
                         {compArr}
                         </div>
                         </div>
                    )
               }
          })

          this.setState({
               materials: groupArr
          })
     }

     render() {
          return (
               <I18nextProvider i18n={i18n}>
               <div className={style.Materials} dir={this.state.dir}>
                    <p className={style.HelperText}>{i18n.t(this.props.helperText)} </p>
                    {this.state.materials}
               </div>
               </I18nextProvider>
          );
     }
}

MaterialSection.propTypes = {
     materials: PropTypes.object.isRequired,
     helperText: PropTypes.string,
     grouping: PropTypes.object.isRequired,
     lang: PropTypes.oneOf([
          'ar',
          'de',
          'en',
          'es',
          'fr',
          'it',
          'ja',
          'ko',
          'nl',
          'pl',
          'pt',
          'ru',
          'tr',
          'uk',
          'vi',
          'zh',
          'zu',
     ]),
};

MaterialSection.defaultProps = {
     lang: 'en',
     helperText: 'Click on the images to learn more about them.'
};
